export default "__VITE_ASSET__645a1e6f__"